import { render, staticRenderFns } from "./savedModal.vue?vue&type=template&id=5acb05a3&scoped=true"
import script from "./savedModal.vue?vue&type=script&lang=js"
export * from "./savedModal.vue?vue&type=script&lang=js"
import style0 from "./savedModal.vue?vue&type=style&index=0&id=5acb05a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acb05a3",
  null
  
)

export default component.exports